<template>
    <div class="testStep">
        <div class="uk-padding-large" style="background: rgba(0, 0, 0, 0.8)">
            <div class="uk-text-center">
                <p style="color: silver" class="">Let FINCOR optimize your business processes to maximize your investment.</p>
                <router-link to="/contact-us" class="uk-button uk-button-default uk-button-large "
                   style="color: silver; font-weight: bolder; color: rgb(197,179,88)"
                >Contact Us</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "callToAction"
    }
</script>

<style scoped>
    .testStep{
        background-image: url('~@/assets/call.png');
        background-size: cover;
    }
</style>